import API from "../api";

function reportBase(role = "admin") {
  const normalized = String(role || "admin").toLowerCase();
  if (normalized === "coach") return "coach";
  if (normalized === "manager") return "manager";
  return "admin";
}

/**
 * Export session attendance report as PDF
 */
export const exportSessionAttendanceReportPdf = (params) => {
  const base = reportBase(params.role);
  return API.get(`/${base}/reports/session-attendance-matrix/pdf`, {
    params: {
      fromDate: params.fromDate,
      toDate: params.toDate,
      batchId: params.batchId || null,
    },
    responseType: "blob",
  });
};

/**
 * Email session attendance report PDF
 */
export const emailSessionAttendanceReport = (payload) => {
  const base = reportBase(payload.role);
  return API.post(`/${base}/reports/session-attendance-matrix/email`, {
    email: payload.email,
    fromDate: payload.fromDate,
    toDate: payload.toDate,
    batchId: payload.batchId || null,
  });
};

export const fetchSessionAttendanceMatrixReport = ({
  role = "admin",
  fromDate,
  toDate,
  batchId,
}) => {
  const base = reportBase(role);
  return API.get(`/${base}/reports/session-attendance-matrix`, {
    params: {
      fromDate,
      toDate,
      batchId: Number(batchId),
    },
  });
};
